import React, {Fragment} from 'react'

const Info = () => {
    return (
        <Fragment>
            <div className="address-block-one d-flex">
            <div className="icon"><img src="images/icon/icon_07.svg" alt=""/></div>
            <div className="text-meta">
                <h4 className="title">Contact Info</h4>
                <p>You can email us directly
                    <br/>
                    <a href="#">contact@salesprototype.com</a>
                </p>
            </div>
        </div>
        </Fragment>
    )
}

export default Info